<template>
  <n-config-provider
    :theme="naiveTheme"
    :theme-overrides="themeOverrides"
    :locale="appLocale"
    :date-locale="appDateLocale"
  >
    <n-message-provider>
      <n-dialog-provider>
        <router-view />
      </n-dialog-provider>
    </n-message-provider>
  </n-config-provider>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { darkTheme, NConfigProvider, NMessageProvider, NDialogProvider } from 'naive-ui'
import { lightThemeOverrides, darkThemeOverrides } from '@/assets/naiveTheme'
import { appLocale, appDateLocale } from '@/core/naive/locale'
import { useThemeStore } from '@/core/store/theme'

const themeStore = useThemeStore()
const { isDark } = storeToRefs(themeStore)

const naiveTheme = computed(() => (isDark.value ? darkTheme : null))
const themeOverrides = computed(() =>
  isDark.value ? darkThemeOverrides : lightThemeOverrides
)
</script>
